module.exports = __webpack_public_path__ + "assets/img/4.11894572.png";